import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

import sobreMiStyles from "../Styles/sobreMi.module.css"
import logos from "../images/logos5.png"
import fotoPerfil from "../images/fotoPerfil.jpg"

const SobreMi = () => {
  return (
    <Layout>
      <SEO title="Sobre mi" />
      <div className={sobreMiStyles.container}>
        <section className={sobreMiStyles.section}>
          <p>
            Programador Web con enfoque inicial en tecnologías Front End a
            través del desarrollo de varios proyectos. Con el objetivo de
            ampliar mis conocimientos incluí el estudio de las tecnologías
            ReactJS y NodeJS para crear un perfil profesional como Programador
            FullStack.
          </p>
          <h3 className={sobreMiStyles.h3}>Tecnologías:</h3>
          <p>
            HTML, CSS, Bootstrap, Sass, JavaScript, GIT, MySQL, NodeJS, ReactJS,
            React Native.
          </p>
        </section>
        <img
          className={sobreMiStyles.photo}
          src={fotoPerfil}
          alt="Foto personal"
        ></img>

        <img
          className={sobreMiStyles.logos}
          src={logos}
          alt="full stack logos"
        ></img>
      </div>
    </Layout>
  )
}

export default SobreMi
